import React from 'react';
import SectorContentBox from './SectorContentbox';
import content from './PagesContent/content';
import SectorFirstPage from './SectorFirstPage';
import SectorCarousal from '../carousal/SectorCarousal';

export default function EducationSector() {
    return (
        <>
            <SectorFirstPage content={content.page5} />
            {content.page5.contentpage.map((element, index) => (
                <React.Fragment key={index}>
                    <SectorContentBox pagecontent={element} />
                    <hr />
                </React.Fragment>
            ))}
            <SectorCarousal removeroute={"/education"}/>
        </>
    );
}
